export const searchHeaderGtm = {
  event: "MdlzcustomEvent",
  GAeventCategory: "searchHeader",
  GAeventAction: "enter or clickButton",
  GAeventLabel: "keyword",
  GAeventValue: 0,
  GAeventNonInteraction: false,
}
export const searchJobGtm = {
  event: "MdlzcustomEvent",
  GAeventCategory: "searchJob",
  GAeventAction: "enter or clickButton",
  GAeventLabel: "keyword",
  GAeventValue: 0,
  GAeventNonInteraction: false,
}
export const formSubmitObj = {
  event: "MdlzcustomEvent",
  GAeventCategory: "downloadForm",
  GAeventAction: "",
  GAeventLabel: "https://dev-subscription.api.mdlzapps.cloud/v1/subscribe/json",
  GAeventValue: 0,
  GAeventNonInteraction: false,
}

export const gaSliderClass = "event_slider"
export const gaEventClick = "event_button_click"
export const gaImageClick = "event_image_click"
export const gaInternalLink = "event_internal_link"
export const gaExternalLink = "event_external_link"
export const gaLogo = "event_logo"
export const gaRightlabel = "clickArrowRight"
export const gaLeftlabel = "clickArrowLeft"
export const gaLogoLabel = "Mondelez International Snacking Made Right - logo"
export const socialMedia = "event_socialmedia_exit"
export const eventSearchRecipeBtn = "event_search_recipe"
export const eventMeasurement = "event_measurement"
export const edit = "edit"
export const done = "done"
export const filterSortBy = "event_filter_sortby"
export const searchRecipeType = "searchRecipe"
export const searchHeaderType = "searchHeader"
export const dotsLabel = "dots"
export const seeMore = "See More"
export const gaMenuClick = "event_menu_click"
export const gaFilterClick = "event_filter_click"
export const gePdfDownload = "event_file_download"
